(ns ycweb.app.website.donation.donation
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as cart.model]
   [ycweb.app.website.common :as common]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc own-amount-donation < rum/reactive [app-atom own-amount-product]
  (let [action-atom (cmn/action-cursor app-atom)
        variation-uuid (:ent/uuid (:item-line/variation own-amount-product))
        selected-atom (rum/cursor-in action-atom [:donation/items variation-uuid])
        {:keys [own-amount]} (rum/react selected-atom)
        add-to-cart-success-callback-fn
        (fn [res]
          (do
            (grid/open-modal app-atom :web.donation/thankyou
              {:config
               {:title "Thank You"}})
            (reset! selected-atom nil)))

        new-cart-enabled
        (cmn/curact app-atom [:features :new-cart])]
    [:div.form-field.u-block-center.u-max-width-480
     [:label.form-label "Donation amount (in ZAR Rand):"]
     [:div.donation-card__form
      [:div.input-combo

       [:div.text-input-wrapper
        (forms/input-raw ""
          (rum/cursor selected-atom :own-amount)
          {:type :currency
           :class [:text-input--zar]})
        [:i.text-input-icon]]
       (buttons/button-web "Add to Cart"
         {:style :primary
          :disabled (if (and (not (nil? own-amount)) (pos? own-amount)) false true)
          :combo true
          :icon :cart
          :has-icon-left true
          :on-click
          (fn [e]
            (.preventDefault e)
            (cond
              new-cart-enabled
              (cart.model/add-to-cart app-atom
                {:variation_uuid (str (:ent/uuid (:item-line/variation own-amount-product)))
                 :qty 1
                 :amount (* own-amount 100)
                 :addsource "donationpage"}
                add-to-cart-success-callback-fn)

              :else
              (common/add-to-cart
                app-atom
                {:url "/donation.htm?action=AddtoCart&overrideincludes=ajax"
                 :success-callback-fn add-to-cart-success-callback-fn
                 :success-key :web.donation/thankyou
                 :error-key :web.donation/error
                 :params
                 {:contentid (:product/id (:item-line/product own-amount-product))
                  :variationid (:variation/id (:item-line/variation own-amount-product))
                  :ownamount own-amount}})))})]]
     [:div.form-hint-wrapper
      [:span.form-hint
       [:b "Note: "]
       "Enter only the number without decimals, e.g. 50."]]]))

(rum/defc donation-card < rum/reactive [app-atom donation-option]
  (let [action-atom (cmn/action-cursor app-atom)
        variation-uuid (:ent/uuid (:item-line/variation donation-option))
        selected-atom (rum/cursor-in action-atom [:donation/items variation-uuid])
        {:keys [qty]} (rum/react selected-atom)
        {:variation/keys [price feature1 code] :as variation} (:item-line/variation donation-option)
        {:keys [colour text-colour emoji-set description] :as display} (:donation/details donation-option)
        add-to-cart-success-callback-fn
        (fn [res]
          (do
            (grid/open-modal app-atom :web.donation/thankyou
              {:config
               {:title "Thank You"}})
            (reset! selected-atom nil)))

        new-cart-enabled
        (cmn/curact app-atom [:features :new-cart])]
    [:div
     {:class (u/bem :flex-grid-block [:xs-1-2 :l-1-4])}
     [:article.donation-card.flex-grid-content {:class (u/bem :card [:no-hover :no-border] colour (when text-colour text-colour))}
      [:div.donation-card__emoji emoji-set]
      [:h2.donation-card__title feature1]
      [:p.donation-card__description description]
      [:p.donation-card__price (str "R" (u/currency-format price) " each")]
      [:div.donation-card__form
       [:div {:class (u/bem :input-combo [:quantity :center])}
        (buttons/button-web ""
          {:style :secondary
           :icon-only true
           :icon :minus
           :on-click #(swap! selected-atom update-in [:qty] dec)
           :class "input-combo__button input-combo__button--plus tooltip tooltip--top"
           :custom-attrs {:data-tooltip "Remove 1"}})
        (forms/input-raw ""
          (rum/cursor selected-atom :qty)
          {:type :text
           :size 3
           :default 0
           :read-only true
           :aria-readonly true})
        (buttons/button-web ""
          {:style :secondary
           :icon-only true
           :icon :plus
           :on-click #(swap! selected-atom update-in [:qty] inc)
           :class "input-combo__button input-combo__button--plus tooltip tooltip--top"
           :custom-attrs {:data-tooltip "Add 1"}})]
       [:p {:class (u/bem :donation-card__price [:total (when (or (nil? qty) (zero? qty)) :disabled)])}
        (str "Total: R" (when qty (u/currency-format (* price qty))))]
       [:div.donation-card__button
        (buttons/button-web "Add to Cart"
          {:type :submit
           :style :primary
           :size :default
           :full true
           :disabled (if (or (nil? qty) (zero? qty)) true false)
           :icon :cart
           :has-icon-left true
           :on-click
           (fn [e]
             (.preventDefault e)
             (cond
               new-cart-enabled
               (cart.model/add-to-cart app-atom
                 {:variation_uuid (str (:ent/uuid variation))
                  :qty (:qty @selected-atom)
                  :addsource "donationpage"}
                 add-to-cart-success-callback-fn)

               :else
               (common/add-to-cart
                 app-atom
                 {:url "/donation.htm?action=AddtoCart&overrideincludes=ajax"
                  :success-callback-fn add-to-cart-success-callback-fn
                  :success-key :web.donation/thankyou
                  :error-key :web.donation/error
                  :params
                  {:contentid (:product/id (:item-line/product donation-option))
                   :variationid (:variation/id variation)
                   :qty qty}})))})]]]]))

(rum/defc donation
  < rum/reactive
  {:did-mount
   (fn [state]
       ;TODO: remove Jquery interop
     #?(:cljs (.fitVids (js/jQuery "#js-forafrika-video")))
     state)}
  [app-atom]
  (let [donation-options (sort-by :listing-order (cmn/curact (cmn/action-cursor app-atom) [:donation-options]))
        product (:item-line/product (first donation-options))
        own-amount-product (cmn/curact (cmn/action-cursor app-atom) [:own-amount-product])
        admin-user? (cmn/curact (cmn/action-cursor app-atom) [:admin-user?])]
    [:main
     {:id "main-content"}
     [:div.header-banner.u-bg-terracotta
      [:div.header-banner__text-wrapper
       [:div.header-banner__text.u-text-white
        [:h1.header-banner__title
         "Give a little love to"
         [:span.u-hidden-from-view "ForAfrika"]]
        (web-common/lazy-image app-atom
          "pages/donations/for-afrika-logo-reversed"
          {:class ["header-banner__logo  u-margin-top-12"]}
          {:q "auto"
           :alt "ForAfrika logo"})]]
      [:div.header-banner__image-wrapper
       (web-common/lazy-image app-atom
         "pages/donations/jam-sa-donations-header-banner"
         {:class ["header-banner__image"]}
         {:w 960
          :mw 490
          :q "auto"
          :alt "ForAfrika Foundation"})]]

     (when admin-user?
       [:div.u-text-center
        {:class (u/bem :yc-section [:standard])}
        (buttons/button-web "Edit product"
          {:href (str "/admin/pages_edit.htm?overrideincludes=popup&sm[e1][action]=contentedit&sm[e1][cntid]=" (:product/id product))
           :target "_blank"
           :style :primary
           :size :default})])

     [:div {:class (u/bem :yc-section [:medium-underline])}
      [:div.yc-intro-text
       (headings/heading "Help us feed more families in need." {:type :h2 :size :medium :center true})
       [:p.yc-paragraph
        "We're partnering with ForAfrika and our customers to help feed hungry South African families. ForAfrika distributes supplies of their fortified porridge to children from 3,000 early childhood development centres across the country, and has also expanded wherever possible to support those children's families with essential food parcels. Donations help them to assist more families who are currently struggling to feed their households."]]
      [:div.u-block-center.u-max-width-480.u-margin-top-20
       [:div.flex-grid-group
        [:div {:class (u/bem :flex-grid-block [:m-1-2 :m-order-02])}
         [:div.flex-grid-content
          (buttons/button-web "Make a donation"
            {:on-click #(scroll/scroll-to-id % "scrollto-make-a-donation")
             :style :primary
             :size :default
             :full true})]]
        [:div {:class (u/bem :flex-grid-block [:m-1-2])}
         [:div.flex-grid-content
          (buttons/button-web "About ForAfrika"
            {:on-click #(scroll/scroll-to-id % "scrollto-about-forafrika")
             :style :secondary
             :size :default
             :full true
             :icon :video
             :has-icon-left true})]]]]]

     [:div {:id "scrollto-make-a-donation" :class (u/bem :yc-section [:medium-underline])}
      (headings/heading "Choose a donation" {:type :h2 :size :medium :center true})
      [:div {:class (u/bem :flex-grid-group [:flush-force :t-align-left :l-align-center])}
       (map (partial donation-card app-atom) donation-options)]
      [:div.u-margin-top-30
       (headings/heading "Or donate your own amount" {:type :h2 :size :medium :center true})
       (own-amount-donation app-atom own-amount-product)]]

     [:div {:id "scrollto-about-forafrika" :class (u/bem :yc-section [:medium])}
      [:article.flex-grid-group.callout-panel
       [:div {:class (u/bem :flex-grid-block [:m-1-2])}
        [:div.flex-grid-content
         [:div.callout-panel__hero
          [:div.video-wrapper.u-max-width-490
           {:id "js-forafrika-video"}
           [:div.fluid-width-video-wrapper
            {:style {:padding-top "50%"}}
            [:iframe.yc-simple-image--shadow
             {:src "https://player.vimeo.com/video/698728394?h=04057626cc&color=a50000&title=0&byline=0&portrait=0"
              :frameBorder 0
              :allowFullScreen true
              :loading "lazy"
              :name "fitvid0"}]]]]]]
       [:div {:class (u/bem :flex-grid-block [:m-1-2])}
        [:div.flex-grid-content
         [:div.callout-panel__content
          (headings/heading "About ForAfrika" {:type :h2 :size :medium})
          [:p.yc-paragraph
           "ForAfrika has been tackling malnutrition in South Africa for more than 15 years, feeding breakfast to 120,000 children every school day, through 3,000 Early Childhood Development centres across the country. One bowl of their own-formulation fortified porridge provides a child with roughly 75% of their daily macro- and micro-nutrient requirements, giving them the full tummy needed for growing, learning and play."]
          [:p.yc-paragraph
           [:i
            "What happened to JAM? You may have seen us supporting JAM (Joint Aid Management) in the past, which was ForAfrika’s previous name. They rebranded globally in 2022, but still have the same team running the same projects that support the same communities, and new ones. "]]
          (buttons/button-web "Make a donation"
            {:on-click #(scroll/scroll-to-id % "scrollto-make-a-donation")
             :style :primary
             :size :default})]]]]]]))

(defmethod flow/render-screen :web.donation [app-atom _]
  (website/screen-wrapper app-atom
    (donation app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.donation [app-atom _ _]
  (toaster/open-overlay app-atom :web.donation)
  (comms/ajax-get :web.donation/list {}))

(defmethod comms/receive :web.donation/list [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :donation-options (:donation-options e)
    :admin-user? (:admin-user? e)
    :own-amount-product (:own-amount-product e))
  (toaster/close-overlay app-atom :web.donation))

(rum/defc thankyou-popup-body []
  [:div.yc-popup.yc-popup--has-footer
   [:div.yc-popup__content
    (headings/heading "Thank you \uD83E\uDD17" {:type :h2 :flush true})]])

(rum/defc thankyou-popup-footer [app-atom]
  (grid/button-row
    {:left-text "Continue Shopping"
     :left-no-icon true
     :left-fn #(grid/close-modal app-atom)
     :right-text "Proceed to Checkout"
     :right-no-icon true
     :right-fn
     #(do
        (grid/close-modal app-atom)
        (if (cmn/curact app-atom [:features :new-cart])
          (urlstate/redirect app-atom "order" "ShowCart")
          #?(:cljs (set! js/window.location "/order.htm?action=ShowCart")
             :clj nil)))}))

(defmethod grid/modal-config :web.donation/thankyou [_ _ _]
  {:body-raw thankyou-popup-body
   :footer thankyou-popup-footer
   :modal-type :alert})

(rum/defc error []
  [:div.yc-popup.yc-popup--has-footer
   [:div.yc-popup__content
    [:p "We didn't manage to add this item to your cart. Please try again, or "
     [:a {:href "contact.htm"} "contact us"]
     " for help."]]])

(defmethod grid/modal-config :web.donation/error [_ _ _]
  {:body-raw error
   :modal-type :alert})